import { FC, ReactNode } from 'react';

type MobileSubMenuProps = {
  children: ReactNode;
  icon?: ReactNode;
  isExpanded: boolean;
  onExpand: (expanded: boolean) => void;
  title: string;
};

export const MobileSubMenu: FC<MobileSubMenuProps> = (props) => {
  const handleExpandToggle = () => {
    if (props.isExpanded) {
      props.onExpand(false);
    } else {
      props.onExpand(true);
    }
  };

  return (
    <li className={`${props.isExpanded ? 'active' : ''}`}>
      <a className='cursor-pointer' onClick={handleExpandToggle}>
        {props.icon}
        {props.title}
        <span className='menu-expand'></span>
      </a>
      <ul
        className='sub-menu'
        style={{ display: props.isExpanded ? 'block' : 'none' }}
      >
        {/*TODO Slide up ul*/}
        {props.children}
      </ul>
    </li>
  );
};
